import React, { useState, useEffect } from 'react';
import { PublicAPI } from '../services/portalApi';

export const MyIpPage: React.FC = () => {
  const [ip, setIp] = useState('');
  const [copied, setCopied] = useState(false);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    PublicAPI.getMyIp()
      .then((res) => setIp(res.data.ip))
      .catch(() => setIp('Unable to detect'))
      .finally(() => setLoading(false));
  }, []);

  const copyIp = () => {
    navigator.clipboard.writeText(ip);
    setCopied(true);
    setTimeout(() => setCopied(false), 2000);
  };

  return (
    <div className="portal-center-page">
      <div className="portal-center-box">
        <div className="portal-card" style={{ textAlign: 'center' }}>
          <h2>Your IP Address</h2>
          {loading ? (
            <p style={{ color: 'var(--text-secondary)' }}>Detecting...</p>
          ) : (
            <>
              <div style={{ fontSize: '2rem', fontWeight: 700, fontFamily: 'monospace', margin: '24px 0', color: 'var(--primary)' }}>
                {ip}
              </div>
              <button className="portal-btn portal-btn-primary" onClick={copyIp}>
                {copied ? 'Copied!' : 'Copy to Clipboard'}
              </button>
              <p style={{ marginTop: 16, fontSize: '0.85rem', color: 'var(--text-secondary)' }}>
                Share this IP with a portal admin to get whitelisted.
              </p>
            </>
          )}
        </div>
      </div>
    </div>
  );
};
